import { motion } from "framer-motion";
import { useLang } from "./LangContext";

export default function Footer() {
  const { t } = useLang();

  return (
    <footer
      data-testid="site-footer"
      className="overflow-hidden border-t border-border bg-foreground px-6 pb-10 pt-20 text-background md:px-12 md:pt-28"
    >
      <div className="mb-16 flex items-center justify-between">
        <span className="font-mono text-[0.68rem] uppercase tracking-[0.2em] text-background/60">
          08 — Coming soon
        </span>
        <span className="font-mono text-[0.68rem] uppercase tracking-[0.2em] text-background/60">
          {t.footer.soon}
        </span>
      </div>

      <motion.h2
        className="w-full whitespace-nowrap font-display font-extrabold uppercase leading-[0.8] tracking-tighter text-[19vw] md:text-[18vw]"
        initial={{ opacity: 0, y: 60 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-10%" }}
        transition={{ duration: 1.1, ease: [0.16, 1, 0.3, 1] }}
      >
        MIDLOWS
      </motion.h2>

      <div className="mt-16 flex flex-col gap-4 border-t border-background/20 pt-8 sm:flex-row sm:items-center sm:justify-between">
        {t.footer.meta.map((m, i) => (
          <span
            key={i}
            className="font-mono text-[0.7rem] uppercase tracking-[0.18em] text-background/70"
          >
            {m}
          </span>
        ))}
      </div>
    </footer>
  );
}
